module.exports = __webpack_public_path__ + "img/logo.8bb3dca5.png";